import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className = '',
  variant = 'primary',
  fullWidth = false,
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#C4956A] disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#C4956A] text-white hover:bg-[#A87B55] shadow-lg shadow-[#C4956A]/20',
    secondary: 'bg-[#4A3728] text-[#FAF7F2] hover:bg-[#3D2B1F]',
    outline: 'border-2 border-[#4A3728] text-[#4A3728] hover:bg-[#4A3728] hover:text-[#FAF7F2]'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  // We cast to any because framer-motion props don't perfectly align with HTMLButtonElement in all TS versions
  // but this is safe for our usage
  const MotionButton = motion.button as any;
  return <MotionButton ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-125">
        {children}
      </MotionButton>;
});
Button.displayName = 'Button';